type Brand = { label: string; src: string; link: string };

export const brands: Brand[] = [
  {
    label: 'Amazing Gaming',
    src: 'https://amazinggaming-web.azurewebsites.net/wp-content/uploads/2021/06/Amazing-Gaming-Logo1.png',
    link: 'https://amazinggaming.com/'
  },
  {
    label: 'Tain',
    src: 'https://amazinggaming-web.azurewebsites.net/wp-content/uploads/2021/06/tain1.png',
    link: 'https://www.tain.com/'
  },
  {
    label: 'Betting Promotion',
    src: 'https://amazinggaming-web.azurewebsites.net/wp-content/uploads/2021/06/Image-321.png',
    link: 'https://www.bettingpromotion.com/'
  },
  {
    label: 'Tech Labs',
    src: 'https://amazinggaming-web.azurewebsites.net/wp-content/uploads/2021/06/iTech-Amazing-Gaming-Certification1.png',
    link: 'https://itechlabs.com/'
  },
  {
    label: 'Gaming Laboratories',
    src: 'https://amazinggaming-web.azurewebsites.net/wp-content/uploads/2021/06/GLI-Global-logo1.png',
    link: 'https://gaminglabs.com/'
  },
  {
    label: 'Isle of Man',
    src: 'https://amazinggaming-web.azurewebsites.net/wp-content/uploads/2021/06/IOM_Logo1.png',
    link: 'https://www.gov.im/categories/business-and-industries/gambling-and-e-gaming/'
  },
  {
    label: 'ONIN',
    src: 'https://amazinggaming-web.azurewebsites.net/wp-content/uploads/2021/06/ONJN-Amazing-Gaming1.png',
    link: 'http://onjn.gov.ro/lista-licentiati-clasa-a-ii-a/'
  },
  {
    label: 'Curaçao Gaming',
    src: 'https://amazinggaming-web.azurewebsites.net/wp-content/uploads/2021/06/Curacao-Amazing-Gaming1.png',
    link: 'https://www.curacao-egaming.com/'
  },
  {
    label: 'MGA',
    src: 'https://amazinggaming-web.azurewebsites.net/wp-content/uploads/2021/06/MGA-Amazing-Gaming1.png',
    link: 'https://www.authorisation.mga.org.mt/verification.aspx?lang=EN&company=137eebf4-5169-441c-b522-21f47efc9967&details=1'
  }
];

export const description = `Tain Betting Promotion Limited is a company registered in accordance with the Maltese 
Laws with company registration number C36814, Registered office: 75, RegentHouse, Bisazza Street, Sliema, SLM 1640, 
Malta. Tain Betting Promotion Limited is licensed and regulated by the Malta Gaming Authority and possesses a B2B 
Critical Supply license, offering Type 1 Gaming Services with license number: MGA/B2B/104/2000. The casino games 
offered by Tain Betting Promotion Limited are licensed under the MGA/B2B/104/2000 licence wich was issued on 1 August 
2018. Tain Betting Promottion Limited is licensed and regulated by the MGA. Tain Betting Promotion Limited is licensed 
and regulated by the Romanian National Gambling Office (ONJN) and is in possession of a Class II-a license for its 
platform and content under decision numbers: nr.1120/29.06.2016 and nr.1129/29.06.2016. Tain Betting Promotion 
International N.V. is in possession of a Curacao license, issued by Curacao eGaming, regulating the production and 
distribution of in-house products and the reselling of content from third parties.`;
